import React, { useCallback, useEffect, useState } from "react";
import "./../Form.scss";
import "./RecebimentosForm.scss";
import { useHistory, useParams } from "react-router";
import service from "../../../services/campanhas";
import { get, post, postCompress } from "../../../services/recebimentos";
import serviceCatalogos from "../../../services/catalogos";
import serviceUsuarios from "../../../services/usuarios";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faArrowLeft,
  faSave,
  faTimes,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import {
  hasText,
  sumValuesArray,
} from "../../../utils/utils";
import { actions as actionsSite } from "../../../redux/actions/site";
import { useDispatch } from "react-redux";
import { toNumber } from "../../../utils/converts";
import { currencyToFloat, formatCurrency } from "../../../utils/Money";
import CheckBox from "../form/generics/CheckBox";
import { actions as actionSite } from "./../../../redux/actions/site";
import TitleModule from "../../../components/title/TitleModule";

const RecebimentosForm = (props) => {

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [usuarios, setUsuarios] = useState([]);
  const [usuariosOptions, setUsuariosOptions] = useState([]);
  const [usuariosOptionsIndexSelected, setUsuariosOptionsIndexSelected] =
    useState(0);
  const [catalogosColunas, setCatalogosColunas] = useState([]);
  const [catalogos, setCatalogos] = useState([]);
  const history = useHistory();
  const params = useParams();
  const [campanha, setCampanha] = useState({});
  const [valorBoleto, setValorBoleto] = useState(1.5);
  const [valorFrete, setValorFrete] = useState(0);
  const initialRecebimento = {
    catalogoCodigo: null,
    usuario: null,
    campanha: null,
    valor: 0,
    semVolume: false,
    semMinimo: false,
    obs:null,
  };
  const [recebimento, setRecebimento] = useState(initialRecebimento);
  const [showOptionsUsuarios, setShowOptionsUsuarios] = useState(false);
  const [recebimentos, setRecebimentos] = useState([]);
  const [recebimentosOrganizados, setRecebimentosOrganizados] = useState([]);
  const [exibirApenasQuemPassouLimite, setExibirApenasQuemPassouLimite] = useState(false);

  const { register, handleSubmit, errors, setValue } = useForm();

  const onSubmit = (data) => {
    save(data);
  };

  const saveRecebimento = async () => {
    const recebimentosLimpo = [...recebimentos].map((r) => {
      const limpo = {
        usuario: r.usuario._id,
        valor: r.valor,
        catalogoCodigo: r.catalogoCodigo,
        campanha: r.campanha,
        semVolume: r.semVolume,
        semMinimo: r.semMinimo,
        obs: r.obs,
      }
      return limpo;
    });
    const body = { valorFrete, valorBoleto, recebimentos: recebimentosLimpo, campanha: campanha._id };

    dispatch(actionsSite.setLoadingMsg("Enviando dados..."));
    const res = await postCompress(`save-recebimentos`, body);
    dispatch(actionsSite.setLoadingMsg(res.msg));
    setTimeout(() => {
        dispatch(actionsSite.setLoadingMsg(""));
        
    }, 3000);
  };

  const carregarCampanha = useCallback(async (id) => {
    const campanhaInicial = await service.getById(id);
    setCampanha(campanhaInicial);
    setValorBoleto(campanhaInicial.valorBoleto);
    setValorFrete(campanhaInicial.valorFrete);
    await carregarRecebimentos(id);
    setLoading(false);
  }, []);

  const carregarRecebimentos = useCallback(async (campanhaId) => {
    const recebimentosCampanha = await get(`by-campanha/${campanhaId}`);
    setRecebimentos(recebimentosCampanha);
    setLoading(false);
  }, []);

  useEffect(() => {
    const run = async () => {
      const _catalogos = serviceCatalogos.get(
        `?catalogo=NULL&sort=apelido&active=true`
      );
      const _usuarios = serviceUsuarios.get(`?active=true&sort=nome`);
      const [_resCatalogos, _resUsuarios] = await Promise.all([
        _catalogos,
        _usuarios,
      ]);
      // setCatalogos(
      //   _resCatalogos.rows.map((e) => {
      //     if (e.codigo) {
      //       return e;
      //     }
      //   })
      // );
      console.log(_resCatalogos,'<<< _resCatalogos');
      const catalogosColunasArr = _resCatalogos.rows.filter(e=>e.codigo).map((e) => {
        
          return {codigo:e.codigo, nome:e.apelido};
        
      });

      // console.log(catalogosColunasArr,'<<< catalogosColunasArr');

      const indexAmway = catalogosColunasArr.findIndex(c=>(c.codigo==="amway"));
      if(indexAmway !== -1){
        catalogosColunasArr.splice(indexAmway,1);
        catalogosColunasArr.push({ codigo: "amway", nome: "Amway" });
      }
      catalogosColunasArr.push({ codigo: "diversos", nome: "Dvs" });

      setCatalogosColunas(catalogosColunasArr);
      setUsuarios(_resUsuarios.rows);
      setUsuariosOptions(_resUsuarios.rows);
      if (params.id) {
        carregarCampanha(params.id);
      } else {
        setLoading(false);
      }
    };
    run();
  }, [carregarCampanha, params.id]);

  useEffect(() => {

    const recebimentosOrg = [];
    for (let rec of recebimentos) {
      const existIndex = recebimentosOrg.findIndex(
        (r) => r.usuario._id === rec.usuario._id
      );

      if (existIndex !== -1) {
        recebimentosOrg[existIndex].catalogos.push({
          catalogoCodigo: rec.catalogoCodigo,
          valor: rec.valor,
          semVolume: rec.semVolume || false,
          semMinimo: rec.semMinimo || false,
          obs: rec.obs || '',
          pedido: rec.pedido || null
        });
      } else {
        recebimentosOrg.push({
          usuario: rec.usuario,
          catalogos: [{ catalogoCodigo: rec.catalogoCodigo, valor: rec.valor, semVolume: rec.semVolume || false, semMinimo: rec.semMinimo || false, obs: rec.obs || '', pedido: rec.pedido || null }],
        });
      }
    }
    setRecebimentosOrganizados(recebimentosOrg);
  }, [recebimentos]);

  const save = async (data) => {
    const clone = { ...recebimento };
    clone.campanha = params.id;
    const cloneRecebimentos = [...recebimentos];
    cloneRecebimentos.push({ ...clone });
    setRecebimentos(cloneRecebimentos);
    clone.usuario = null;
    clone.valor = 0;
    clone.semVolume = false;
    clone.semMinimo = false;
    setRecebimento(clone);
    setValue("valor", "0,00");
    setValue("semVolume", false);
    setValue("semMinimo", false);
    document.querySelector("#usuario").focus();

  };

  const changeValueMoney = (e, campo) => {
    let value = e.target.value;
    const lastChar = value.substr(-1);
    const firstChar = value.substr(0, 1);
    let signal = firstChar === "-" ? "-" : "";
    if (lastChar === "+" || lastChar === "-") {
      if (firstChar !== lastChar) {
        signal = lastChar === "-" ? "-" : "";
      }
    }
    value = value.replace(/[+-]/g, "");
    const newValue = formatCurrency(signal + value);
    setValue(campo, newValue);
    document.querySelector("#" + campo).classList.add("hasText");
    const clone = { ...recebimento };
    clone.valor = currencyToFloat(e.target.value);
    setRecebimento(clone);
  };

  const changeCatalogo = (e) => {
    const clone = { ...recebimento };
    clone.catalogoCodigo = e.target.value;
    setRecebimento(clone);
  };

  const optionCatalogos = () => {
    const op = [...catalogosColunas];
    
    op.unshift({ codigo: "", nome: "Selecione um catálogo" });
    return op.map((o, i) => {
      return (
        <option key={i} value={o.codigo}>
          {o.nome}
        </option>
      );
    });
  };

  const selecionaUsuario = (usuario) => {
    const clone = { ...recebimento };
    clone.usuario = usuario;
    setShowOptionsUsuarios(false);
    setRecebimento(clone);
  };

  const unsetUsuarioSelecionado = () => {
    const clone = { ...recebimento };
    clone.usuario = null;
    setRecebimento(clone);
  };

  const filterOptionsUsuarios = (e) => {
    const value = e.target.value;
    if (value.length >= 2) {
      const clone = [...usuarios];
      const filtered = clone.filter((usuario) => {
        const test =
          usuario.nome.toUpperCase().indexOf(value.toUpperCase()) !== -1;
        return test;
      });
      setUsuariosOptionsIndexSelected(0);
      setUsuariosOptions(filtered.slice(0, 10));
      setShowOptionsUsuarios(true);
    } else {
      setUsuariosOptions([]);
      setShowOptionsUsuarios(false);
    }
  };

  const selectOptionsUsuarios = (e) => {
    let nextIndex = 0;
    if (["ArrowUp", "ArrowDown", "Tab"].includes(e.key)) {
      if (["ArrowDown", "Tab"].includes(e.key)) {
        nextIndex = usuariosOptionsIndexSelected + 1;
        if (nextIndex > usuariosOptions.length - 1) {
          nextIndex = 0;
        }
      } else {
        nextIndex = usuariosOptionsIndexSelected - 1;
        if (nextIndex < 0) {
          nextIndex = usuariosOptions.length - 1;
        }
      }
      setUsuariosOptionsIndexSelected(nextIndex);
    }
    if (["Enter"].includes(e.key)) {
      if (showOptionsUsuarios) {
        selecionaUsuario(usuariosOptions[usuariosOptionsIndexSelected]);
        document.querySelector("#valor").focus();
      }
    }

    if (["Tab"].includes(e.key)) {
      if (showOptionsUsuarios) {
        e.preventDefault();
      }
    }

    if (["Enter"].includes(e.key)) {
      e.preventDefault();
    }
  };

  const renderLancamentosModal = (catalogo, recebimento) => {
    const valores = recebimento.catalogos.filter(
      (c) => c.catalogoCodigo === catalogo.codigo
    );
    return (
      <table
        className="lancamentosPorCatalogos"
        cellSpacing={0}
        cellPadding={0}
      >
        <thead>
          <tr>
            <td align="right">Sem volume</td>
            <td align="right">Sem mínimo</td>
            <td align="left">Obs</td>
            <td align="right">Valor</td>
            <td align="right">Ação</td>
          </tr>
        </thead>
        <tbody>
          {valores.map((valor, index) => {
            const indexRecebimento = recebimentos.findIndex((r) => {
              if (
                r.catalogoCodigo === valor.catalogoCodigo &&
                r.valor === valor.valor &&
                r.usuario._id === recebimento.usuario._id
              ) {
                return true;
              }
            });
            return (
              <tr key={index}>
                <td align="right">{valor.semVolume ? 'Sim' : 'Não'}</td>
                <td align="right">{valor.semMinimo ? 'Sim' : 'Não'}</td>
                <td align="left" width={300}>
                {!valor.pedido && (<input type="text" onChange={(e)=>{
                  const value = e.target.value;
                  mudaObsRecebimento(indexRecebimento, value);

                  }} defaultValue={valor.obs} />)}
                  {valor.pedido && (<div>Pedido nº {valor.pedido.sequencia} <a className="verPedido" href={`/painel/pedidos-venda/view/${valor.pedido._id}`} rel="noreferrer noopener" target={'_blank'}>ver pedido</a></div>)}
                </td>
                <td align="right">{formatCurrency(valor.valor)}</td>
                <td align="right">
                  {!valor.pedido && (
                    <button
                      className="delete"
                      onClick={() => {
                        modalConfirmaRecebimentoExclusao(
                          catalogo,
                          recebimento,
                          indexRecebimento
                          );
                        }}
                      >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  )}
                </td>
              </tr>
            )
          })}
        </tbody>
        <tfoot>
          <tr className="titulo">
            <td align="right" colSpan={4}>Total</td>
            <td></td>
          </tr>
          <tr>
            <td align="right" colSpan={4}>
              {formatCurrency(sumValuesArray(valores.map((v) => v.valor)))}
            </td>
            <td></td>
          </tr>
        </tfoot>
      </table>
    );
  };

  const voltarModalEditaRecebimento = (params) => {
    modalEditaRecebimento(params.catalogo, params.recebimento);
  };

  const modalConfirmaRecebimentoExclusao = (
    catalogo,
    recebimento,
    indexRecebimento
  ) => {
    const configModal = {
      msg: "Confirma a exlusão do lançamento?",
      //component: renderLancamentosModal(catalogo, recebimento),
      title: `${recebimento.usuario.nome} - ${catalogo.nome}`,
      actions: [
        {
          label: "Sim",
          class: "azul",
          callback: excluirRecebimento,
          arg: { indexRecebimento },
        },
        {
          label: "Voltar",
          class: "cinza",
          callback: voltarModalEditaRecebimento,
          arg: { catalogo, recebimento },
        },
      ],
    };

    dispatch(actionSite.setModal(configModal));
  };

  const modalEditaRecebimento = (catalogo, recebimento) => {
    const configModal = {
      msg: "",
      component: renderLancamentosModal(catalogo, recebimento),
      title: `${recebimento.usuario.nome} - ${catalogo.nome}`,
    };

    dispatch(actionSite.setModal(configModal));
  };

  const excluirRecebimento = (params) => {
    const clone = [...recebimentos];
    clone.splice(params.indexRecebimento, 1);
    setRecebimentos(clone);
    dispatch(actionSite.setModal(null));
  };

  const mudaObsRecebimento = (indexRecebimento, value) => {
    const clone = [...recebimentos];
    clone[indexRecebimento].obs = value;
    setRecebimentos(clone);
  };

  const renderRecebimentos = () => {
    recebimentosOrganizados.sort((a,b) => a.usuario.nome.toUpperCase() > b.usuario.nome.toUpperCase() ? 1 : -1)
    return recebimentosOrganizados.map((r, index) => {
      const totalValores = r.catalogos.map((c) => c.valor);
      totalValores.push(r.usuario.taxaManuseio || 0);
      const volumes = r.catalogos.filter(c=>(!c.semVolume)).length;
      return (
        <tr key={index} style={
          (exibirApenasQuemPassouLimite ? 
            (r.usuario.limite && r.usuario.limite < sumValuesArray(totalValores)) ? {} : {display:'none'} : {})
        }>
          <td>{r.usuario.nome}</td>
          <td>{r.usuario.diasPagamento.join(", ")}</td>
          <td>{formatCurrency(r.usuario.taxaManuseio || 0)}</td>
          {catalogosColunas.map((cat, index) => {
            const lancamentosCatalogo = r.catalogos
            .filter((c) => c.catalogoCodigo === cat.codigo);
            const valores = [...lancamentosCatalogo].map((c) => c.valor);
            const somaValores = sumValuesArray(valores);
            const temSemMinimo = [...lancamentosCatalogo].find(e=>e.semMinimo);
            let classesTd = [];
            if(somaValores > 0) classesTd.push("editavel");
            if (temSemMinimo) classesTd.push("semMinimo");
            return (
              <td key={index} align="right">
                <div
                  className={classesTd.join(" ")}
                  onClick={() => {
                    if (somaValores > 0) {
                      modalEditaRecebimento(cat, r);
                    }
                  }}
                >
                  {formatCurrency(somaValores)}
                </div>
              </td>
            );
          })}
          <td align="right" style={
            (r.usuario.limite && r.usuario.limite < sumValuesArray(totalValores)) ? {color:'red'} : {}
          }>{formatCurrency(sumValuesArray(totalValores))}
          </td>
          <td align="center">{volumes}</td>
          <td></td>
        </tr>
      );
    });
  };

  const getTotalFrete = () => {
    const fretes = [];
    for (let rec of recebimentosOrganizados) {
      fretes.push(rec.usuario.taxaManuseio || 0);
    }
    return formatCurrency(sumValuesArray(fretes));
  };

  const getTotalFaturas = () => {
    const faturas = recebimentosOrganizados.filter((r) => {
      if (
        r.usuario.diasPagamento.length > 0 &&
        (r.usuario.pagamentoAvista || r.usuario.pagamentoFaturado)
      ) {
        return true;
      }
    });

    if (faturas.length > 0) {
      return faturas
        .map((b) => b.usuario.diasPagamento.length)
        .reduce((prev, curr) => prev + curr);
    }

    return 0;
  };

  const getTotalBoletos = () => {
    const boletos = recebimentosOrganizados.filter((r) => {
      if (
        r.usuario.diasPagamento.length > 0 &&
        !r.usuario.pagamentoAvista &&
        !r.usuario.pagamentoFaturado
      ) {
        return true;
      }
    });

    if (boletos.length > 0) {
      return boletos
        .map((b) => b.usuario.diasPagamento.length)
        .reduce((prev, curr) => prev + curr);
    }

    return 0;
  };

  const getTotalGeral = () => {
    const valores = [];
    for (let rec of recebimentosOrganizados) {
      valores.push(rec.usuario.taxaManuseio || 0);
      for (let cat of rec.catalogos) {
        valores.push(cat.valor || 0);
      }
    }
    return formatCurrency(sumValuesArray(valores));
  };

  const getTotalCatalogo = (catalogoCodigo) => {
    const valores = [];
    for (let rec of recebimentosOrganizados) {
      for (let cat of rec.catalogos) {
        if (cat.catalogoCodigo === catalogoCodigo) {
          valores.push(cat.valor || 0);
        }
      }
    }
    return formatCurrency(sumValuesArray(valores));
  };

  const getTotalVolume = () => {
    const valores = [];
    for (let rec of recebimentosOrganizados) {
      valores.push(rec.catalogos.filter(c=>(!c.semVolume)).length);
    }
    return sumValuesArray(valores);
  };

  const renderBotaoSalvar = () => {
    return (
      <div className="form recebimento">
        <form
          onSubmit={handleSubmit(saveRecebimento)}
          className="formModule branco RecebimentosForm"
        >
          <div className="acoes  mt-10">
            <button
              type="button"
              className="salvar"
              onClick={() => saveRecebimento()}
            >
              <FontAwesomeIcon icon={faSave} /> Salvar
            </button>
          </div>
        </form>
      </div>
    );
  };

  const flagSemVolume = (campo, checked) => {
    setValue(campo, checked);
    const clone = {...recebimento};
    clone.semVolume = checked;
    setRecebimento(clone);
  }

  const flagSemMinimo = (campo, checked) => {
    setValue(campo, checked);
    const clone = {...recebimento};
    clone.semMinimo = checked;
    setRecebimento(clone);
  }

  const flagPassouLimite = (campo, checked) => {
    setExibirApenasQuemPassouLimite(checked);
  }


  return (
    <>
      {!loading && (
        <TitleModule
          titulo={`Recebimentos - Editar Campanha ${campanha.codigo}`}
        />
      )}
      {!loading && (
        <>
          <div
            className="form recebimento"
            onClick={() => setShowOptionsUsuarios(false)}
          >
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="formModule branco RecebimentosForm"
            >
              <div className="acoes">
                <button
                  type="button"
                  className="cancelar"
                  onClick={() => history.push("/painel/recebimentos")}
                >
                  <FontAwesomeIcon icon={faArrowLeft} /> Voltar
                </button>
              </div>
              <div className="break"></div>
              <h3 className="tituloEtapa">Novo recebimento</h3>
              <div className="break"></div>
              <div className={errors.catalogoCodigo ? "field error" : "field"}>
                <select
                  name="catalogoCodigo"
                  className="hasText"
                  ref={register({ required: true })}
                  id="catalogoCodigo"
                  value={recebimento.catalogoCodigo || ""}
                  onChange={(e) => changeCatalogo(e)}
                >
                  {optionCatalogos()}
                </select>
                <label htmlFor="catalogoCodigo">Catálogo</label>
              </div>

              <div className={errors.usuario ? "field error" : "field"}>
                {recebimento.usuario && (
                  <div className="autocomplete selected">
                    <input
                      className={"hasText"}
                      name="usuario"
                      id="usuario"
                      type="text"
                      readOnly
                      value={recebimento.usuario.nome}
                    />
                    <div
                      className="unset"
                      onClick={() => {
                        unsetUsuarioSelecionado();
                      }}
                    >
                      x
                    </div>
                  </div>
                )}
                {!recebimento.usuario && (
                  <input
                    className={"hasText"}
                    name="usuario"
                    id="usuario"
                    onKeyUp={(e) => {
                      hasText(e);
                    }}
                    onChange={(e) => {
                      filterOptionsUsuarios(e);
                    }}
                    onKeyDown={(e) => {
                      selectOptionsUsuarios(e);
                    }}
                    onClick={(e) => e.stopPropagation()}
                    ref={register({ required: true })}
                    autoComplete="off"
                    type="text"
                  />
                )}
                <label htmlFor="valor" className="hasText">
                  Revendedora
                </label>
                {showOptionsUsuarios && (
                  <ul id="options" tabIndex="0">
                    {usuariosOptions.map((v, index) => {
                      return (
                        <li
                          key={index}
                          className={
                            index === usuariosOptionsIndexSelected
                              ? "selected"
                              : ""
                          }
                          onClick={() => selecionaUsuario(v)}
                        >
                          {v.nome}
                        </li>
                      );
                    })}
                  </ul>
                )}
              </div>

              <div className={errors.valor ? "field error" : "field"}>
                <input
                  className={"hasText"}
                  name="valor"
                  id="valor"
                  onKeyUp={(e) => {
                    hasText(e);
                  }}
                  onChange={(e) => {
                    changeValueMoney(e, "valor");
                  }}
                  ref={register({
                    required: true,
                    validate: (value) => toNumber(value) !== 0,
                  })}
                  defaultValue={formatCurrency(recebimento.valor)}
                  type="text"
                />
                <label htmlFor="valor">Valor</label>
              </div>

              <div className={"fieldButton"}>
                {recebimento.semVolume && 
                  <CheckBox label="Sem Volume" value="semVolume" checked={true} callback={flagSemVolume} showIcon />}
                {!recebimento.semVolume && 
                  <CheckBox label="Sem Volume" value="semVolume" checked={false} callback={flagSemVolume} showIcon />}
              </div>

              <div className={"fieldButton"}>
                {recebimento.semMinimo && 
                  <CheckBox label="Sem Mínimo" value="semMinimo" checked={true} callback={flagSemMinimo} showIcon />}
                {!recebimento.semMinimo && 
                  <CheckBox label="Sem Mínimo" value="semMinimo" checked={false} callback={flagSemMinimo} showIcon />}
              </div>

              <div className="fieldButton">
                <button type="submit" className="salvar">
                  <FontAwesomeIcon icon={faAngleDown} /> Inserir
                </button>
              </div>
              <div className="break"></div>
            </form>
            {errors && Object.keys(errors).length > 0 && (
              <div className="erros">
                <div>
                  <FontAwesomeIcon icon={faTimes} /> Existem erros no formulário
                </div>
              </div>
            )}
          </div>

          <form className="formModule branco RecebimentosForm">
            <div className="break"></div>
            <h3 className="tituloEtapa mt-10">Lista de recebimentos</h3>
            <div className="break"></div>
            <div className="filtrosGrid">
              <div className={"fieldButton"}>
                {exibirApenasQuemPassouLimite && 
                  <CheckBox label="Mostrar quem passou o limite" value="exibirApenasQuemPassouLimite" checked={true} callback={flagPassouLimite} showIcon />}
                {!exibirApenasQuemPassouLimite && 
                  <CheckBox label="Mostrar quem passou o limite" value="exibirApenasQuemPassouLimite" checked={false} callback={flagPassouLimite} showIcon />}
              </div>
            </div>
            {/* <pre>{JSON.stringify(catalogosColunas,null,2)}</pre> */}
            
            <div className="crudView" style={{ width: "100%" }}>
              <div className="gridView">
                <table
                  cellPadding="0"
                  cellSpacing="0"
                  className="recebimentosGrid"
                >
                  <thead>
                    <tr>
                      <td>Revendedora</td>
                      <td>Vcto</td>
                      <td>Frete</td>
                      {catalogosColunas.map((cat, index) => {
                        return (
                          <td key={index} align="right">
                            {cat.nome.toUpperCase()}
                          </td>
                        );
                      })}
                      <td align="right">Total</td>
                      <td>Vol</td>
                      <td></td>
                    </tr>
                  </thead>
                  <tbody>{renderRecebimentos()}</tbody>
                  <tfoot>
                    <tr className="totais">
                      <td align="right">Faturas</td>
                      <td align="right">Boletos</td>
                      <td align="right">Frete</td>
                      {catalogosColunas.map((cat, index) => {
                        return (
                          <td key={index} align="right">
                            {cat.nome.toUpperCase()}
                          </td>
                        );
                      })}
                      <td align="right">Total</td>
                      <td>Vol</td>
                      <td></td>
                    </tr>
                    <tr className="">
                      <td align="right">{getTotalFaturas()}</td>
                      <td align="right">{getTotalBoletos()}</td>
                      <td align="right">{getTotalFrete()}</td>
                      {catalogosColunas.map((cat, index) => {
                        return (
                          <td key={index} align="right">
                            {getTotalCatalogo(cat.codigo)}
                          </td>
                        );
                      })}
                      <td align="right">{getTotalGeral()}</td>
                      <td>{getTotalVolume()}</td>
                      <td></td>
                    </tr>
                  </tfoot>
                </table>

                <table
                  cellPadding="0"
                  cellSpacing="0"
                  className="recebimentosGrid mt-10 w-auto floatRight"
                >
                  <thead>
                    <tr>
                      <td>Total Frete</td>
                      <td>Valor Boleto</td>
                      <td>Total Boletos</td>
                      <td>Frete</td>
                      <td>Total</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{getTotalFrete()}</td>
                      <td>
                        <input
                          className={"hasText"}
                          name="valorBoleto"
                          id="valorBoleto"
                          onChange={(e) => {
                            const valor = currencyToFloat(e.target.value);
                            setValorBoleto(valor);
                          }}
                          value={formatCurrency(valorBoleto)}
                          type="text"
                        />
                      </td>
                      <td>{formatCurrency(getTotalBoletos() * valorBoleto)}</td>
                      <td>
                        <input
                          className={"hasText"}
                          name="valorFrete"
                          id="valorFrete"
                          onChange={(e) => {
                            const valor = currencyToFloat(e.target.value);
                            setValorFrete(valor);
                          }}
                          value={formatCurrency(valorFrete)}
                          type="text"
                        />
                      </td>
                      <td>
                        {formatCurrency(
                          currencyToFloat(getTotalFrete()) -
                            valorFrete -
                            getTotalBoletos() * valorBoleto
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </form>

          {renderBotaoSalvar()}

          {/* <textarea
            style={{ width: "100%", height: "100px" }}
            value={JSON.stringify(recebimentos)}
          ></textarea> */}
        </>
      )}
      {loading && "Carregando..."}
    </>
  );
};

export default RecebimentosForm;
